import axios from '_u/axios'
const blob = axios.create({
    responseType: 'blob',
})

// 园区列表
export const assetsParkList = (body) => {
    return axios.post('api/assets/park/list', body)
}

// 园区列表(带权限)
export const assetsParkRootList = () => {
    return axios.post('api/assets/park/chooseList')
}

// 园区新增
export const assetsParkAdd = (body) => {
    return axios.post('api/assets/park/add', body)
}

// 园区查看
export const assetsParkView = (id) => {
    return axios.post('api/assets/park/view', { id })
}

//园区更新
export const assetsParkUpdate = (body) => {
    return axios.post('api/assets/park/update', body)
}

// 园区禁用启用
export const assetsParkEnable = (id) => {
    return axios.post('api/assets/park/enable', { id })
}

// 园区删除
export const assetsParkDelete = (id) => {
    return axios.post('api/assets/park/delete', { id })
}

// 合同模板-列表
export const contractTplList = (body) => {
    return axios.post('api/setting/contracttpl/list', body)
}

// 合同模板-启用/禁用
export const contractTplEnable = (id) => {
    return axios.post('api/setting/contracttpl/enable', { id })
}

// 合同模板-下载
export const contractTplDownload = (id) => {
    return blob.post('api/setting/contracttpl/download', { id })
}

// 合同模板-查看
export const contractTplView = (body) => {
    if (typeof body === 'string') {
        body = { id: body }
    }
    return axios.post('api/setting/contracttpl/view', body)
}

// 合同模板-修改合同模板罚款比例
export const updateRentOverduePunish = (body) => {
    return axios.post('api/setting/contracttpl/updateRentOverduePunish', body)
}

// 合同模板-修改是否默认标识
export const updateDefault = (id) => {
    return axios.post('api/setting/contracttpl/updateDefault', { id })
}


// 获取园区下有效房源总数
export const countHouseById = (id) => {
    return axios.post('api/assets/park/countHouseById', { id })
}


